export default {
  practice: {},
  record: {},
  timer: {},
  stepList: {},
  report: {},
  entrance: {},
  logo: { data: {} },
};



// WEBPACK FOOTER //
// ./src/reducers/initial_state.js